// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"51ec6b79","201":"bb8d7c62","298":"1803a2e8","427":"00996372","472":"cd24526c","550":"65d2864f","772":"5f78814b","787":"c7e32d0e","862":"b156639c","964":"9e457617"}[chunkId] + ".chunk.js";
};